import React from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import Main from '@/components/main'
import Scroll from '@/components/scroll'
import { config } from '@/lib/config'
import { OrganizationSchema, LocalBusinessSchema, WebSiteSchema } from '@/components/StructuredData'

export default function Home() {
  const navigate = useNavigate()

  const handleClick = () => {
    navigate('/lelek-szinei')
  }

  return (
    <>
      <Helmet>
        <title>BeArt Művészetterápia</title>
        <meta name="description" content="BeArt Művészetterápia, Art Coaching, családállítás, coaching, önismeret - művészetterápiás csoportok, egyéni és csoportos alkalmak, szervezeteknek kiégés megelőzés programok, önismereti foglalkozások" />
        <meta name="keywords" content="művészetterápia, art coaching, családállítás, coaching, önismeret" />
        <meta property="og:title" content="BeArt Művészetterápia" />
        <meta property="og:description" content="BeArt Művészetterápia, Art Coaching, családállítás, coaching, önismeret" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://beart.hu" />
        <meta property="og:image" content="https://beart.hu/images/og-image.jpg" />
        <link rel="canonical" href="https://beart.hu" />
      </Helmet>
      
      {/* Structured Data */}
      <OrganizationSchema />
      <LocalBusinessSchema />
      <WebSiteSchema url="https://beart.hu" name="BeArt Művészetterápia" />
      
      <Main />
      <Scroll />
    </>
  )
}
